/**
 * 配列内の項目のカウント数を足し合わせる
 *
 * @param 配列
 *
 * @return オブジェクト
 */
/* eslint-disable */
const getAnimation = function (i) {
  if (i === 0) return ''
  else if (i === 1) return ''
  else if (i === 2) return 'huyuu'
  else if (i === 3) return 'guruguru'
  else if (i === 4) return 'kakusyuku'
  else return ''
}

export default getAnimation



// WEBPACK FOOTER //
// ./src/functions/getAnimation.js